import { configureStore } from '@reduxjs/toolkit';
import apiReducer from './apiSlice';
import userdataReducer from './controller';
import seasonReducer from "./seasonSlice"

export const store = configureStore({
  reducer: {
    api: apiReducer,
    userdata: userdataReducer,
    season: seasonReducer,
    // Add other reducers if needed
  },
});